import WithRender from "../../templates/containers/pageOptionAttributesContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getActiveProductPageOptions"]),

    getProductPageOptionValues: function () {
      if (this.getActiveProductPageOptions[this.code]) {
        return this.getActiveProductPageOptions[this.code].values;
      }
      return [];
    }
  },
  props: ["propsData", "code", "hideContainer"]
});
